/* eslint-disable @typescript-eslint/naming-convention */
import { Directive, Input } from '@angular/core';

/**
 * Adds a machine-readable "agent layer" to an element so it can be reliably
 * discovered and operated by automation agents (e.g. GitHub Copilot browser tools).
 *
 * Usage:
 *   <button
 *     appAgentAction
 *     agent="save-order"
 *     businessObject="order"
 *     [businessId]="order.id"
 *     action="save">
 *     Save
 *   </button>
 */
@Directive({
  selector: '[appAgentAction]',
  host: {
    '[attr.data-agent]': 'agent',
    '[attr.data-business-object]': 'businessObject ?? null',
    '[attr.data-business-id]': 'businessId ?? null',
    '[attr.data-action]': 'action ?? null',
  },
})
export class AgentActionDirective {
  /** Stable, unique agent identifier for this control (e.g. "save-order"). */
  @Input({ required: true }) public agent!: string;

  /** Business object type the control operates on (e.g. "order", "nwNumber"). */
  @Input() public businessObject?: string;

  /** Identifier of the concrete business object instance (e.g. "4711"). */
  @Input() public businessId?: string | number | null;

  /** Action the control performs (e.g. "save", "delete", "export"). */
  @Input() public action?: string;
}
